module.exports = __webpack_public_path__ + "img/ic_workout_categories_arrow.54583d99.svg";